<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="20" width="20">
    <g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 20 20)">
      <g clip-path="url(#clip0_4899_15368)">
        <path
            d="M19.4008 11.213C19.7275 11.213 19.9924 10.948 19.9924 10.6213V1.93153C19.9924 1.60477 19.7275 1.33988 19.4008 1.33988H15.8362V11.213H19.4008Z"
            :fill="color"/>
        <path
            d="M0.00753021 7.94579C0.00753021 8.69685 0.411087 9.35544 1.01273 9.71615C0.782221 10.049 0.647025 10.4528 0.647025 10.8874C0.647025 12.0247 1.57226 12.9499 2.70949 12.9499H7.06333C6.92989 13.5546 6.74739 14.462 6.62032 15.4119C6.28961 17.8838 6.51563 19.2547 7.33153 19.7261C7.8402 20.02 8.38864 20.0796 8.87583 19.8941C9.2522 19.7508 9.76048 19.3983 10.0501 18.5333L11.1944 15.5371C11.7745 14.1044 13.5511 12.6003 14.6528 11.7687V1.07808C12.6109 0.362616 10.4801 -4.19617e-05 8.30626 -4.19617e-05H3.56227C2.42504 -4.19617e-05 1.4998 0.925194 1.4998 2.06242C1.4998 2.46067 1.61328 2.83293 1.80957 3.14852C1.12203 3.48336 0.647101 4.18938 0.647101 5.00411C0.647101 5.4388 0.782297 5.84251 1.0128 6.1754C0.411085 6.5361 0.00753021 7.19474 0.00753021 7.94579Z"
            :fill="color"/>
      </g>
      <defs>
        <clipPath id="clip0_4899_15368">
          <rect width="20" height="20" :fill="color" transform="matrix(-1 0 0 -1 20 20)"/>
        </clipPath>
      </defs>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LikedIcon',
  props: {
    color: {
      type: String,
      default: 'white'
    },
  }
};
</script>

<style scoped lang="scss">

</style>
